/*
 * IMPORTS
 */
import { gql } from '@apollo/client' // Npm: Apollo client for handling graphql request.


/*
 * GRAPHS
 */
const SystemInformationReadUniqueQuery = gql`
  query SystemInformationReadUnique {
    SystemInformationReadUnique {
      cpu
      cpuArchitecture
      currentLoad
      diskInfo
      freeMemory
      fsSize
      memory
      message
      operatingSystem
      serverStatus
      status
      totalMemory
      uptime
    }
  }
`


/*
 * EXPORTS
 */
export default SystemInformationReadUniqueQuery
